import find from './find.js';

export default function getFocusableElements(element, selector='') {
  const focusableElements = find(
    element,
    `button:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${selector},
     [href][clientHeight][clientWidth]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${selector},
     input:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${selector},
     select:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${selector},
     textarea:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${selector},
     [contenteditable]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${selector},
     [tabindex]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${selector}`
  );

  const visibleFocusableElements = [];
  for (const focusableElement of focusableElements) {
    if (getComputedStyle(focusableElement).display != 'none' && getComputedStyle(focusableElement).visibility != 'hidden')
      visibleFocusableElements.push(focusableElement);
  }
  return visibleFocusableElements;
}
